import React from "react";
import PageSeo from "components/Seo/PageSeo";
import PageHero from "components/PageHero/PageHero";
import VisitUs from "components/Home/VisitUs/VisitUs";
import { localBusinessSchema } from "helpers/seo/schema";
import "components/Home/homeShared.css";

const Contact = () => (
    <main className="contact-page">
      <PageSeo
        title="Contact Ace Gymnastics"
        description="Contact Ace Gymnastics in Bardstown, KY. Call 502-252-8512, email office@ace-gymnastics.com, or visit us at 2388 New Haven Road."
        path="/contact"
        jsonLd={localBusinessSchema()}
      />
      <PageHero
        title="Contact Us"
        subtitle="Questions about classes, events, or visiting the gym? We would love to hear from your family."
        imageAlt="Ace Gymnastics gym in Bardstown, Kentucky"
      />
    <VisitUs />
  </main>
);

export default Contact;
